import { menuArray } from './fieldTypes';

// Create a basic enhanced menu array without icons for utility purposes
// Icons should be handled by the consuming components that have access to image assets
const getEnhancedMenuArray = () => {
  return menuArray.map((item) => {
    const enhancedItem = { ...item };
    
    if (item.child) {
      enhancedItem.child = item.child.map((child) => ({
        ...child,
      }));
    }
    
    return enhancedItem;
  });
};

/**
 * Get field configuration based on field type
 * @param {Object} field - Field object containing type, label, inputType etc.
 * @returns {Object|null} Field configuration object or null if not found
 */
export const getFieldConfig = (field) => {
  // Get enhanced menu array and flatten it to include both parent items and child items
  const enhancedMenuArray = getEnhancedMenuArray();
  const allFieldTypes = [];

  enhancedMenuArray.forEach((item) => {
    if (item.child) {
      // Add child items
      allFieldTypes.push(...item.child);
    } else {
      // Add parent items that don't have children
      allFieldTypes.push(item);
    }
  });

  // More robust matching logic - prioritize exact matches first
  return (
    allFieldTypes.find(
      (config) => config.name === field?.type || config.label === field?.type,
    ) ||
    allFieldTypes.find(
      (config) =>
        config.name === field?.label ||
        config.label === field?.label ||
        config.inputType === field?.inputType,
    )
  );
};

/**
 * Get field-specific settings from modalSettingsObj
 * @param {Object} field - Field object
 * @param {Object} modalSettingsObj - Settings object containing field-specific configurations
 * @returns {Object} Field-specific settings or empty object
 */
export const getFieldSettings = (field, modalSettingsObj) => {
  if (!modalSettingsObj || !field) return {};

  const fieldType = field.type || field.name;
  return modalSettingsObj[fieldType] || {};
};
